import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=356e2466&scoped=true&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"
import style0 from "./particulars.vue?vue&type=style&index=0&id=356e2466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e2466",
  null
  
)

export default component.exports